import * as types from './types'
export default {
  [types.SET_STEP](state, data) {
    state.step = data
  },
  [types.SET_ADDRESSES](state, data) {
    state.originalAddresses = data.originalAddresses
    state.addresses = data.addresses
    data.originalAddresses.forEach(original => {
      state.addresses.forEach(address => {
        if (parseInt(original.ID) === parseInt(address.id)) {
          address.original = original
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/usps/mutations.js